/** Shared Business-Unit utilities used by top filter components. */

import { UNALLOCATED_BUSINESS_UNIT } from '../constants/buConstants';

export const BU_ORDER = [
  'Delivery | Cloud Engineering',
  'Delivery | Data Engineering',
  'Delivery | Cloud Security & Reliability Engineering',
  'Delivery | Decision Intelligence Engineering',
  'Delivery | Modern Product Engineering',
  'Delivery | Modern Work Ops Engineering',
  'Delivery | AI Engineering',
  'Client Success',
  'Client Innovation & Capabilities',
];

export const sortBusinessUnits = (businessUnits: string[]): string[] => {
  const sorted: string[] = [];
  const remaining = [...businessUnits];
  const unallocatedIdx = remaining.indexOf(UNALLOCATED_BUSINESS_UNIT);
  if (unallocatedIdx !== -1) {
    remaining.splice(unallocatedIdx, 1);
  }
  BU_ORDER.forEach((bu) => {
    const idx = remaining.indexOf(bu);
    if (idx !== -1) { sorted.push(bu); remaining.splice(idx, 1); }
  });
  sorted.push(...remaining.sort());
  if (unallocatedIdx !== -1) {
    sorted.push(UNALLOCATED_BUSINESS_UNIT);
  }
  return sorted;
};

/** Normalize SBU names so variants like "EU  ME" and "EU + ME" are treated as equal. */
export const normalizeSbuName = (name: string): string =>
  name ? name.replace('  ', ' + ') : name;

export const areSbusEqual = (a: string, b: string): boolean =>
  normalizeSbuName(a) === normalizeSbuName(b);

export const listContainsSbu = (list: string[], value: string): boolean =>
  (list || []).some((item) => areSbusEqual(item, value));
